import { postRequest } from '../../../shared/utils';

export async function getColumnGroupDropDown(screenGridId, configSchema, colGroupWhere) {
  const body = {
    columns: [
      'attr_group_id',
      'mbd_attribute_group{attribute_group_name_en attribute_group_name_de}',
    ],
    screenGridId,
    schema: configSchema,
    table: 'mbd_screen_grid_attribute_config',
    filterModel: colGroupWhere,
    orderCol: 'mbd_attribute_group:{attribute_group_name_en',
    order: 'asc}',
  };
  const { errors, data } = await postRequest('/api/records', body);

  if (errors) {
    return { errors };
  }
  return data[configSchema + '_mbd_screen_grid_attribute_config'];
}
